import React from "react";
import Router from "./components/Router/Router";
import ErrorBoundary from "./components/common/ErrorBoundary/ErrorBoundary";
import NotificationProvider from "./contextApis/NotificationContext";
import RequiredDataProvider from "./contextApis/RequiredDataContext";
import RouteProvider from "./contextApis/RouteContext";
import TenantProvider from "./contextApis/TenantContext";
import UserSessionProvider from "./contextApis/UserSessionContext";

const App = () => {
  return (
    <ErrorBoundary>
      <UserSessionProvider>
        <TenantProvider>
          <RequiredDataProvider>
            <RouteProvider>
              <NotificationProvider>
                <Router />
              </NotificationProvider>
            </RouteProvider>
          </RequiredDataProvider>
        </TenantProvider>
      </UserSessionProvider>
    </ErrorBoundary>
  );
};

export default App;
